<template>
  <div class="bg">
    <div class="item" v-for="item in list" :key="item.id">
      <div class="top-status">订单时间：{{ item.createTime }}</div>
      <div class="top-status">权益订单号：{{ item.orderId }}</div>
      <!-- 0:待付款， 1：已完成， 2：已退款, 3:充值中, 4:充值失败 -->
      <div class="top-status">
        订单状态：{{
          [0].includes(item.status)
            ? '待付款'
            : [1].includes(item.status)
            ? '已完成'
            : [2].includes(item.status)
            ? '已退款'
            : [3].includes(item.status)
            ? '充值中'
            : [4].includes(item.status)
            ? '充值失败'
            : '无'
        }}
      </div>
      <van-button
        color="#F7AF2F"
        @click="refunds(item)"
        v-if="item.status === 1"
        >退款</van-button
      >
    </div>
  </div>
</template>

<script>
import { getOrder, refundOrder } from '@/api/api.js'
import { Toast } from 'vant'
export default {
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getOrderList()
  },
  methods: {
    async getOrderList() {
      const { data } = await getOrder({
        pageNum: 1,
        pageSize: 1000,
        param: {
          openId: this.$route.query.openid
        }
      })
      console.log('order', data)
      this.list = data?.records || []
    },
    async refunds(val) {
      await refundOrder(val)
      Toast.success('退款成功')
      this.getOrderList()
    }
  }
}
</script>

<style lang="less" scoped>
.bg {
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
}
.item {
  margin: 15px;
  background: #fff;
  padding: 15px;
  overflow: hidden;
  .van-button {
    float: right;
  }
  .top-status {
    padding-bottom: 5px;
  }
}
</style>
